/* Glowie Starter Kit UX fixes (20.10.2026) */
(function () {
  var TICK = /^\s*(✓|✔|&#10003;|&check;)\s*/;

  function cleanBanner(el) {
    if (TICK.test(el.textContent)) {
      el.textContent = el.textContent.replace(TICK, '');
    }
  }

  function setupBanner(root) {
    root.querySelectorAll('[data-sk-count]').forEach(function (el) {
      if (el.__skFix) return;
      el.__skFix = true;
      cleanBanner(el);
      new MutationObserver(function () { cleanBanner(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function setupToggle(root) {
    root.querySelectorAll('.sk-drawer-footer').forEach(function (footer) {
      var label = footer.querySelector('.sk-drawer-slot-labels .sk-label-included');
      if (!label || label.classList.contains('sk-incl-toggle')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = label.className + ' sk-incl-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span>What’s included?</span><span class="sk-incl-chevron" aria-hidden="true"></span>';
      var notice = footer.querySelector('.sk-drawer-glue-notice');
      if (notice) {
        if (!notice.id) notice.id = 'sk-incl-panel-' + Math.random().toString(36).slice(2, 8);
        btn.setAttribute('aria-controls', notice.id);
      }
      btn.addEventListener('click', function () {
        var open = footer.classList.toggle('sk-incl-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      label.parentNode.replaceChild(btn, label);
    });
  }



  /* ---------- Cart drawer (re-applied every time the drawer refreshes) ---------- */
  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu;
  var busy = false;

  function setText(el, txt) { if (el.textContent !== txt) el.textContent = txt; }

  function enhanceCart(c) {
    if (busy) return;
    busy = true;
    try {
      // Free shipping bar, Etoile style: text on the left, amount left on the right
      var card = c.querySelector('.cd-shipping-card');
      if (card) {
        var msg = card.querySelector('.cd-milestone-header-msg');
        var row = card.querySelector('.gx-ship-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'gx-ship-row';
          row.innerHTML = '<span class="gx-ship-text"></span><span class="gx-ship-left"></span>';
          card.insertBefore(row, card.firstChild);
        }
        var raw = (msg ? msg.textContent : '').replace(EMOJI, '').replace(/\s+/g, ' ').trim();
        var amount = raw.match(/[A-Z]{0,3}[$€£]\s?[\d.,]+/);
        var text = raw, left = '';
        if (/^add\b/i.test(raw) && amount) { text = 'Get free shipping'; left = amount[0] + ' left'; }
        else if (/unlocked/i.test(raw)) { text = 'You’ve unlocked free shipping'; }
        setText(row.querySelector('.gx-ship-text'), text);
        setText(row.querySelector('.gx-ship-left'), left);
      }

      // EDIT button next to the quantity selector on kit bundles
      c.querySelectorAll('.cd-item-block').forEach(function (block) {
        var link = block.querySelector('a[data-bundle-edit-link]');
        var qtyRow = block.querySelector('.cd-qty-counter-row');
        if (!link || !qtyRow || qtyRow.querySelector('.gx-edit-btn')) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gx-edit-btn';
        btn.textContent = 'Edit';
        btn.setAttribute('aria-label', 'Edit the designs in this kit');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var current = block.querySelector('a[data-bundle-edit-link]');
          if (current) current.click();
        });
        qtyRow.appendChild(btn);
      });

      // Prep + Application tools badge wording
      c.querySelectorAll('.cd-kit-item-card').forEach(function (card) {
        var name = card.querySelector('span');
        var badge = card.lastElementChild;
        if (!name || !badge || !/prep\s*\+\s*application tools/i.test(name.textContent)) return;
        if (/free included on/i.test(badge.textContent)) setText(badge, '✓ Free on all Starter Kits');
      });
    } finally {
      busy = false;
    }
  }

  function setupCart() {
    var c = document.querySelector('[data-cart-drawer-container]');
    if (!c || c.__gxFix) return;
    c.__gxFix = true;
    enhanceCart(c);
    new MutationObserver(function () { enhanceCart(c); })
      .observe(c, { childList: true, characterData: true, subtree: true });
    // flag the page while the cart is open (used to hide the chat button)
    var syncOpen = function () { document.documentElement.classList.toggle('gx-cart-open', c.classList.contains('is-open')); };
    syncOpen();
    new MutationObserver(syncOpen).observe(c, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Menu: fill the empty fallback link with "Shop All" ---------- */
  function setupMenu() {
    document.querySelectorAll('a.cn-mob-link, a.cn-nav-link').forEach(function (a) {
      if (a.textContent.trim() !== '') return;
      a.textContent = 'Shop All';
      a.setAttribute('href', '/collections/shop-all');
    });
  }

  function init() {
    setupBanner(document);
    setupToggle(document);
    setupCart();
    setupMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { setupBanner(e.target); setupToggle(e.target); });
})();
